module.exports = __webpack_public_path__ + "img/loading1.0e7dbc97.gif";